<div class="status-container">
    <div class="status-bar" [style.background-color]="color"></div>
    <div class="status-content">
      <div [ngClass]="{'totalValue': customSize}">{{ totalValue }}</div>
      <div [ngClass]="{'description': customSize}">{{ description }}</div>
    </div>
  </div>
  